module.exports = __webpack_public_path__ + "img/medical-attention.6b81183b.jpg";